package com.eladfinish.bible.contest.common

import com.eladfinish.bible.contest.di.customSerializers
import kotlinx.serialization.json.Json

val json by lazy {
    Json {
        ignoreUnknownKeys = true
        explicitNulls = false
        prettyPrint = true
        serializersModule = customSerializers
    }
}
